import React from 'react';
import { Button } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

export enum BookButtonState {
    Disabled = 'disabled',
    Loading = 'loading',
    Enabled = 'enabled',
}

interface BookButtonContainerProps {
    isSearchCriteriaUpdated: boolean;
    handleUpdateSelected: (e: React.MouseEvent) => void;
    handleOptionSelected: (e: React.MouseEvent) => void;
    bookButtonState: BookButtonState;
    offerTitle: string;
    isMarginRequired: boolean;
    width: 'parent-fit' | 'content-fit';
    bookButtonRef: React.RefObject<HTMLButtonElement>;
    offerIndex: number;
    bookingFormUrl?: string;
}

const BookButtonContainer: React.FC<BookButtonContainerProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    const ariaLabel = React.useMemo(() => {
        if (props.bookButtonState === BookButtonState.Loading) {
            return `${cms[326495]} ${props.offerTitle}`;
        }

        if (props.isSearchCriteriaUpdated) {
            return `${cms[190714]} ${props.offerTitle}`;
        }

        return `${cms[54393]} ${props.offerTitle}`;
    }, [props.bookButtonState, props.isSearchCriteriaUpdated, props.offerTitle, cms]);

    return (
        <>
            <Button
                aria-live="polite"
                onClick={props.isSearchCriteriaUpdated ? props.handleUpdateSelected : props.handleOptionSelected}
                data-element-name={props.isSearchCriteriaUpdated ? 'activities-booking-options-update-button' : 'activities-booking-options-book-button'}
                data-testid={props.isSearchCriteriaUpdated ? 'activities-booking-options-update-button' : 'activities-booking-options-book-button'}
                data-element-index={props.offerIndex + 1}
                state={props.bookButtonState}
                width={props.width}
                variant="label"
                ms={props.isMarginRequired ? '12' : '0'}
                aria-label={ariaLabel}
                label={props.isSearchCriteriaUpdated ? cms[190714] : cms[54393]}
                ref={props.bookButtonRef}
            />
            {props.bookingFormUrl && (
                <a aria-hidden="true" hidden={true} tabIndex={-1} href={props.bookingFormUrl}>
                    {cms[54393]}
                </a>
            )}
        </>
    );
};

BookButtonContainer.displayName = 'BookButtonContainer';

export default BookButtonContainer;
